// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__ylR+h","active":"styles_active__q0VBr"};